export const days = [
  {
    value: 1,
    label: {
      en: '01',
      ne: '०१',
    },
  },
  {
    value: 2,
    label: {
      en: '02',
      ne: '०२',
    },
  },
  {
    value: 3,
    label: {
      en: '03',
      ne: '०३',
    },
  },
  {
    value: 4,
    label: {
      en: '04',
      ne: '०४',
    },
  },
  {
    value: 5,
    label: {
      en: '05',
      ne: '०५',
    },
  },
  {
    value: 6,
    label: {
      en: '06',
      ne: '०६',
    },
  },
  {
    value: 7,
    label: {
      en: '07',
      ne: '०७',
    },
  },
  {
    value: 8,
    label: {
      en: '08',
      ne: '०८',
    },
  },
  {
    value: 9,
    label: {
      en: '09',
      ne: '०९',
    },
  },
  {
    value: 10,
    label: {
      en: '10',
      ne: '१०',
    },
  },
  {
    value: 11,
    label: {
      en: '11',
      ne: '११',
    },
  },
  {
    value: 12,
    label: {
      en: '12',
      ne: '१२',
    },
  },
  {
    value: 13,
    label: {
      en: '13',
      ne: '१३',
    },
  },
  {
    value: 14,
    label: {
      en: '14',
      ne: '१४',
    },
  },
  {
    value: 15,
    label: {
      en: '15',
      ne: '१५',
    },
  },
  {
    value: 16,
    label: {
      en: '16',
      ne: '१६',
    },
  },
  {
    value: 17,
    label: {
      en: '17',
      ne: '१७',
    },
  },
  {
    value: 18,
    label: {
      en: '18',
      ne: '१८',
    },
  },
  {
    value: 19,
    label: {
      en: '19',
      ne: '१९',
    },
  },
  {
    value: 20,
    label: {
      en: '20',
      ne: '२०',
    },
  },
  {
    value: 21,
    label: {
      en: '21',
      ne: '२१',
    },
  },
  {
    value: 22,
    label: {
      en: '22',
      ne: '२२',
    },
  },
  {
    value: 23,
    label: {
      en: '23',
      ne: '२३',
    },
  },
  {
    value: 24,
    label: {
      en: '24',
      ne: '२४',
    },
  },
  {
    value: 25,
    label: {
      en: '25',
      ne: '२५',
    },
  },
  {
    value: 26,
    label: {
      en: '26',
      ne: '२६',
    },
  },
  {
    value: 27,
    label: {
      en: '27',
      ne: '२७',
    },
  },
  {
    value: 28,
    label: {
      en: '28',
      ne: '२८',
    },
  },
  {
    value: 29,
    label: {
      en: '29',
      ne: '२९',
    },
  },
  {
    value: 30,
    label: {
      en: '30',
      ne: '३०',
    },
  },
  {
    value: 31,
    label: {
      en: '31',
      ne: '३१',
    },
  },
  {
    value: 32,
    label: {
      en: '32',
      ne: '३२',
    },
  },
] as const;
